import { useTour } from '@reactour/tour';
import { useEffect } from 'react';

import { useModal } from '@/components/common/modal';
import { useAuth } from '@/features/auth';
import {
  sendTeamsNotification,
  TeamsNotificationType,
} from '@/features/demo/services/notification';
import { getTourStep } from '@/features/demo/steps';
import { CreateFermentationModal } from '@/features/fermentation/components/create-fermentation-modal';
import { CreateAnalysisWizard } from '@/features/single-measurement';
import { useSettings } from '@/features/user-settings';
import { useRoute } from '@/hooks/use-route';
import { DashboardHomeLayout } from '@/layouts';

import { DashboardCard } from '../components/dashboard-card';

export const WineHomePage = () => {
  const { routeToAnalysisHistory, routeToFermentationTracking } = useRoute();

  const { settings } = useSettings();
  const { user, turnOffInitialDemoMode } = useAuth();

  const { isOpen, toggle } = useModal();
  const { isOpen: fermentationIsOpen, toggle: fermentationToggle } = useModal();

  const { isOpen: isTourOpen, currentStep, setCurrentStep, setIsOpen, steps } = useTour();

  useEffect(() => {
    // if demo is enabled for user, we open the demo from step 0
    if (settings.isDemoMode && currentStep === 0) {
      setIsOpen(true);
    }

    // trigger step 'luZY2o3' when user get back to home
    if (isTourOpen && currentStep === getTourStep(steps, 'dzsFe6t')) {
      setCurrentStep(getTourStep(steps, 'luZY2o3'));
      setIsOpen(true);
    }

    // trigger step 'Dm7QIsT' when user get back to home
    if (isTourOpen && currentStep === getTourStep(steps, 'Dm7QIsT')) {
      setCurrentStep(getTourStep(steps, 'wuwV2GN'));
      setIsOpen(true);
    }

    // trigger step 'BWbcFaA' when user get back to home
    if (isTourOpen && currentStep === getTourStep(steps, 'BWbcFaA')) {
      setCurrentStep(getTourStep(steps, '3dIOlms'));
      setIsOpen(true);
    }
  }, []);

  useEffect(() => {
    // notify teams upon the start of demo
    if (isTourOpen && currentStep === 0) {
      sendTeamsNotification({
        name: `${user?.first_name} ${user?.last_name}`,
        email: `${user?.email}`,
        type: TeamsNotificationType.Started,
      });
    }
  }, [isTourOpen]);

  useEffect(() => {
    // opens demo mode if user type has enabled demo by default
    // check 'useAuth > signin method'
    if (user?.initialDemoMode) {
      setCurrentStep(0);
      setIsOpen(true);
      turnOffInitialDemoMode();
    }
  }, [user]);

  return (
    <div id="step-wine-dashboard">
      <CreateAnalysisWizard isOpen={isOpen} close={toggle} />
      <CreateFermentationModal isOpen={fermentationIsOpen} toggle={fermentationToggle} />
      <DashboardHomeLayout>
        <DashboardCard
          id="step-wine-fermentation-tracking"
          secondaryBtnId="step-wine-tracking-overview-btn"
          variation="light"
          title="home.fermentationTracking"
          onNewTracking={fermentationToggle}
          primaryButtonLabel="home.addNewTracking"
          secondaryButtonLabel="home.showMoreTracking"
          onSecondaryButton={routeToFermentationTracking}
        />
        <DashboardCard
          id="step-wine-single-measurements”"
          primaryBtnId="step-wine-new-analysis"
          secondaryBtnId="step-wine-analysis-history-btn"
          variation="dark"
          onNewTracking={toggle}
          title="home.singleAnalysis"
          primaryButtonLabel="home.startNewAnalysis"
          secondaryButtonLabel="measurements.title"
          onSecondaryButton={routeToAnalysisHistory}
        />
      </DashboardHomeLayout>
    </div>
  );
};
